import React from "react";
import styled from "styled-components";
import PretendardText from "./../text/pretendardText";

const GrayBtn = (props) => {
  return (
    <StyledGrayBtn
      style={{
        backgroundColor: "#272829",
        ...props.style,
      }}
      onClick={props.onClick}
    >
      <PretendardText
        style={{
          color: "#aaa",
          fontSize: "14px",
          fontWeight: "500",
          lineHeight: "22.75px",
          textAlign: "center",
        }}
      >
        {props.children || props.text}
      </PretendardText>
    </StyledGrayBtn>
  );
};

export default GrayBtn;

const StyledGrayBtn = styled.button.attrs((props) => {})`
  width: fit-content;
  height: fit-content;
  padding: 3px 8px;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.12);
`;
